import { Map as map } from 'immutable';
let C  = require("../constants");

function PriceReducer(state = map(), action) {
    switch (action.type) {
        case C.SELECT_PRICE:
            return action.price;
        default:
            return state;
    }
}

export default PriceReducer;


// WEBPACK FOOTER //
// ./src/reducers/PriceReducer.js